/** Import modules */

import { useQuery }             from "@apollo/client";

/** Import queries */

import { SingleProduct }        from "../Queries/Rims";

/**
 * 
 * @param { params } attr 
 * 
 * @returns Tyres product collection model
 * 
 */

const Product = ( id ) => { const

    { loading, data, error } = useQuery ( SingleProduct, {

        variables: { id: id ? [ id ] : [] },

        skip: ! id

    } );

    /** Return model */

    return { loading, data, error }

}

/** Export model */

export default Product;